import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../../services/users/users.service';
import { SessionService } from '../../services/session/session.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private UsersService: UsersService,
    private SessionService: SessionService
  ) {}

  login(user: NgForm) {
    console.log(user);
    if (!user || !user.valid) return;
    this.UsersService.login(user.value)
      .then((result: any) => {
        if (result.msg == 'you are already registered ') {
          this.toastr.error(result.msg);
        } else {
          if (this.SessionService.isAdmin()) this.router.navigate(['panel']);
          else this.router.navigate(['image-editor']);
        }
      })
      .catch((err) => {
        this.toastr.error('Not allowed to login');
        err = err || new Object();
      });
  }
  ngOnInit(): void {
    var user = this.SessionService.loggedInUser();
    if (user) this.router.navigate(['image-editor']);
    console.log(user);
  }
}
